<template>

    <form v-on:submit="save" action="#" method="post" id="profile-form">

      <div class="row">

          <div class="col-xs-4">
              <div class="form-group ">
                <label for="name" class="required">Profile name</label>
                <input id="name" v-model="profile.name" class="form-control" required>
                <span v-if="errorName" class="help-block text-danger">{{this.errorName}}</span>
            </div>
          </div>

        <div class="col-xs-4">
          <div class="form-group ">
            <label for="profile_logo" class="required">Logo</label>
            <input id="profile_logo" v-model="profile.logo" class="form-control" required disabled>
            <span v-if="errorLogo" class="help-block text-danger">{{this.errorLogo}}</span>
          </div>
        </div>

        <div class="col-xs-4">
          <div class="form-group ">
            <label for="logo_link" class="required">Logo link</label>
            <input id="logo_link" v-model="profile.logo_link" class="form-control" required>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-xs-4">
          <div class="form-group ">
            <label for="color_expert" class="required">Color Expert</label>
            <input id="color_expert" v-model="profile.color_expert" class="form-control" required>
          </div>
        </div>

        <div class="col-xs-4">
          <div class="form-group ">
            <label for="nb_simultaneous_access" class="required">Simultaneous Access</label>
            <input type="number" min="-1" max="10" id="nb_simultaneous_access" v-model="profile.nb_simultaneous_access" class="form-control" disabled>
          </div>
        </div>
        <div class="col-xs-4">
          <div class="form-group ">
            <label for="individual_plans_exception_list" class="" data-toggle="popover" data-content="List of email domain names associated with the profile. The corresponding e-mail addresses cannot see & access individual plans. They must be separated by ';' "  data-original-title="" >email domain names <i class="fa fa-info-circle text-info"></i></label>
            <textarea id="individual_plans_exception_list" class="form-control" v-model="profile.individual_plans_exception_list" placeholder="nexans.com;total.com..."></textarea>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-xs-4">
        <div class="form-group">
          <label>Logo
            <span v-if="errorLogo" class="error">{{ errorLogo }}</span>
          </label>
          <div class="row" v-if="profile.logo">
            <div  class="col-xs-12">
              <div class="hpanel">
                <div class="panel-heading" style="height: 40px">
                  <div class="pull-right">
                    <button type="button" class="btn btn-danger btn-xs btn-outline" ><i class="fa fa-remove"></i> Remove</button>
                  </div>
                </div>
                <a :href="$apiUrl + profile.logo" target="_blank">

                  <template v-if="/(jpg|jpeg|png)$/ig.test(profile.logo)">
                    <div class="panel-body file-body" style="padding: 10px">
                      <div style="height: 70px; max-width: 100%">
                        <img :src="$apiUrl + profile.logo" width="100%" style="max-height: 70px" :title="profile.logo.match('.*\/(.*)')[1]">
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="panel-body file-body" style="padding: 57px">
                      <template v-if="/(pdf)$/ig.test(profile.logo)">
                        <i class="fa fa-file-pdf-o text-danger"></i>
                      </template>
                      <template v-else-if="/(doc|docx)$/ig.test(profile.logo)">
                        <i class="fa fa-file-word-o text-info"></i>
                      </template>
                      <template v-else-if="/(xlsx|xlsm|xlsb|xls)$/ig.test(profile.logo)">
                        <i class="fa fa-file-excel-o text-success"></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-file-o text-dark"></i>
                      </template>

                    </div>
                  </template>
                </a>
                <div class="panel-footer">
                  <a :href="$apiUrl + profile.logo" target="_blank">{{profile.logo.match('.*\/(.*)')[1]}}</a>
                </div>

              </div>
            </div>
          </div>
          <div class="example-btn">

            <label class="btn btn-primary btn-outline btn-sm file-uploads file-uploads-html5"><i class="fa fa-plus"></i>
              Select Image (160x70px)<span v-if="uploadFiles.length !== 0">{{uploadFiles[0].name}} - {{uploadFiles[0].size}} kb</span>
              <input type="file" name="picture" style="display: none" accept="image/*" @change="onChange($event)">
            </label>
          </div>
          <span class="help-block m-b-none" style="margin-bottom: 10px"> Profile website logo </span>
        </div>
        </div>
      </div>

      <div class="row">
        <div class="text-center m-t-xs">
          <router-link class="btn btn-default" :to="{name: 'PreviewProfile', params: {id: profile.id}}">
             Cancel
          </router-link>
        <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle"> Save </vue-ladda>
      </div>
      </div>
    </form>
</template>

<style scoped>

</style>
<script>

import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  name: 'ProfileSettings',
  props: ['profile'],
  data () {
    return {
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      action: 'patch',
      errorName: null,
      errorLogo: null,
      uploadFiles: []
    }
  },
  methods: {
    save: function (event) {
      event.preventDefault()
      this.upload().then((response) => {
        this.submit.loading = true
        let method = this.action === 'create' ? 'post' : 'patch'
        let data = {
          name: this.profile.name,
          logo: this.profile.logo,
          individual_plans_exception_list: this.profile.individual_plans_exception_list
        }

        this.axios[method]('/profile/' + (this.profile !== null ? this.profile.id : ''), data)
          .then((response) => {
            this.$notify({
              type: 'success',
              title: '',
              content: 'Datas has been updated successfully',
              placement: 'bottom-right'
            })
          })
          .catch((error) => {
            if (error.response.status === 400) {
              let errors = error.response.data.errors
              switch (error.response.data.code) {
                case 1:
                  this.errorName = errors['name'][0]
                  break
                case 2:
                  this.errorLogo = errors['logo'][0]
                  break
              }
            }
            this.$notify({
              type: 'danger',
              title: 'The datas cannot be validated',
              content: 'All mandatory fields (with *) have to be completed',
              placement: 'bottom-right'
            })
          })
          .finally(() => {
            this.submit.loading = false
          })
      })
    },
    getResources: function () {
    },
    onChange: function (event) {
      this.uploadFiles = []

      this.uploadFiles.push(event.target.files[0])
    },
    upload: function () {
      return new Promise((resolve, reject) => {
        if (this.uploadFiles.length !== 0) {
          let data = new FormData()

          this.uploadFiles.forEach((file) => {
            data.append('files[]', file)
          })
          data.append('target', 'profile_logo')

          this.axios.post('/files/', data)
            .then((response) => {
              this.uploadFiles.forEach((file) => {
                if (typeof response.data.files[file.name] !== 'undefined') {
                  this.profile.logo = '/' + response.data.path + response.data.files[file.name]
                }
              })
              this.uploadFiles = []
              resolve(response)
            })
            .catch((error) => {
              if (typeof error.response !== 'undefined' && error.response.status === 413) {
                this.$notify({
                  type: 'danger',
                  title: 'An error has occurred, max upload size is 10 Mo',
                  placement: 'bottom-right'
                })
              }
              this.submit.loading = false
              reject(error)
            })
        } else {
          resolve(null)
        }
      })
    }
  },
  mounted () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      container: '#profile-form',
      html: true
    })
  },
  beforeMount () {
    this.getResources()
  }

}
</script>



// WEBPACK FOOTER //
// src/components/profile/ProfileSettings.vue